// React
import { useContext } from "react"

// Components
import { CreatePage } from "pages/Card/Transaction/CreateNewVendor/components"

// Contexts
import { IframeContext } from "contexts"

export function CreateNewVendor(): JSX.Element {
  // Hooks
  const { onClose } = useContext(IframeContext)

  return (
    <CreatePage
      asModal
      onSuccess={onClose}
    />
  )
}